const APP_URL = 'https://dev.paperless.commonsense.events';
const API_URL = 'https://dev.api.paperless.commonsense.events'; 

export const environment = {
  production: false,
  app_url: APP_URL,
  api_url: API_URL
};
